'use strict';
const PNR_STATUS = {
    ACCEPTED: 'ACCEPTED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    REDEMPTION_PENDING: 'REDEMPTION_PENDING',
};

const argsValidator = (status, pnrs) => Object.keys(PNR_STATUS).includes(status) && !Odigeo._.isEmpty(pnrs);

module.exports = Backbone.Model.extend({
    PNR_STATUS,
    bookingId: null,
    buyerName: null,
    buyerMail: null,
    bookingCreationDate: null,
    confirmationLayerShown: null,

    defaults: {
        openTicketPNRs: {},
        acceptedPNRs: [],
        pendingPNRs: [],
        rejectedPNRs: [],
        redemptionPendingPNRs: [],
        renderPNRCards: true,
    },

    addPNRs(status, ...pnrs) {
        if (argsValidator(status, pnrs)) {
            const pnrList = this.getPNRList(status);
            pnrs.filter((pnr) => pnrList.indexOf(pnr) === -1).forEach((pnr) => pnrList.push(pnr));
            this.trigger(`change:${status.toLowerCase()}PNRs`);
        }
    },

    removePNR(status, pnr) {
        if (argsValidator(status, pnr)) {
            const pnrList = this.getPNRList(status);
            const index = pnrList.indexOf(pnr);
            if (index !== -1) {
                pnrList.splice(index, 1);
                this.trigger(`change:${status.toLowerCase()}PNRs`);
            }
        }
    },

    getPNRList(status) {
        switch (status) {
            case PNR_STATUS.ACCEPTED:
                return this.get('acceptedPNRs');
            case PNR_STATUS.PENDING:
                return this.get('pendingPNRs');
            case PNR_STATUS.REJECTED:
                return this.get('rejectedPNRs');
            case PNR_STATUS.REDEMPTION_PENDING:
                return this.get('redemptionPendingPNRs');
            default:
                return [];
        }
    },

    acceptOpenTicket: function(pnr) {
        this.removePNR(PNR_STATUS.PENDING, pnr);
        this.addPNRs(PNR_STATUS.ACCEPTED, pnr);
    },

    rejectOpenTicket: function(pnr) {
        this.removePNR(PNR_STATUS.ACCEPTED, pnr);
        this.removePNR(PNR_STATUS.PENDING, pnr);
        this.addPNRs(PNR_STATUS.REJECTED, pnr);
    },
});
